/*
  车型页进入的分类集合（/collections/{分类}/{品牌-车型}?vehicle=<年份页 handle>）：隐藏不适配这台车的商品
  （运营 2026-09-29「同一个 Silverado 里不同年份 / 型号的配件还混在一起」）。

  适配以权威表「专车专用品车型库」为准（运营 2026-10-13，不再按商品标题判断）：适配商品存在年份页 metaobject 的 part_handles 字段
  （docs/vehicle-pages-data-model.zh-CN.md；scripts/vehicle-pages-build-part-fitment.py 生成导入文件），与车型页分类卡（snippets/auxito-proto-shell-cat-url.liquid）读同一个字段；
  车型库没有行的商品隐藏。这里按 ?vehicle= 用 Section Rendering 读该年份页的 sections/auxito-vehicle-page-data.liquid（只输出这一个字段，几百字节）。
  数据读取失败时不展示未确认适配的商品，显示提示和重试（PR #55 第五轮审查：原来失败时照常显示同车系全部商品）。
  车型由 snippets/breadcrumbs.liquid 确认存在后通过 window.__apspCollectionVehicle / apsp:collection-vehicle 事件给出，
  手改的假车型不会触发过滤。
*/
(function () {
  'use strict';

  var dataPromise = null;

  /* 返回 { pages: { <年份页 handle>: [适配商品 handle…] } }（结构与迁移前的 JSON 一致） */
  function loadData(yh) {
    if (!dataPromise) {
      /* 15 秒没返回按读取失败处理（显示重试），不让商品一直停在待确认状态 */
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : 0;
      dataPromise = fetch('/pages/vehicle-year/' + encodeURIComponent(yh) + '?section_id=auxito-vehicle-page-data', { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) {
          clearTimeout(timer);
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.querySelector('script[data-apsp-part-fitment]');
          if (!node) throw new Error('no data');
          var list = JSON.parse(node.textContent || 'null');
          /* 不是年份页（null）或格式不对：上下文不正确，按失败处理，不当成「本车没有配件」 */
          if (!Array.isArray(list)) throw new Error('not a vehicle year page');
          var pages = {};
          pages[yh] = list.map(function (h) { return String(h).toLowerCase(); });
          return { pages: pages };
        });
      dataPromise.catch(function () { clearTimeout(timer); dataPromise = null; }); /* 失败不缓存，重试时重新读 */
    }
    return dataPromise;
  }

  /* 商品卡链接 /collections/x/products/<handle> 或 /products/<handle> → handle */
  function handleOf(item) {
    var link = item.querySelector('a[href*="/products/"]');
    var m = link && /\/products\/([^/?#]+)/.exec(link.getAttribute('href'));
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  }

  function fitsHandle(data, yh, handle) {
    var list = data && data.pages && data.pages[yh];
    return !!(list && handle && list.indexOf(handle) >= 0);
  }

  /* 侧栏是商品旧标签生成的筛选（For Cadillac / For Chevy / For GMC…），车型已经选定、商品按权威表过滤后再列别的车型没有意义，
     还会让人以为页面混了其他车（运营 2026-10-29）。确认是年份页车型后隐藏侧栏、按无侧栏排版；读取失败（车型不对）时保留。
     只隐藏不删除：主题 Load more 按侧栏里选中的标签（.filter-item--active）拼下一页网址，删掉会丢掉车型标签、拉到别的车的商品 */
  function dropSidebar() {
    var side = document.getElementById('productgrid--sidebar');
    if (!side) return;
    var outer = side.closest('.productgrid--outer');
    side.style.display = 'none';
    if (outer) { outer.classList.remove('layout--has-sidebar'); outer.classList.add('layout--no-sidebar'); }
  }

  function apply(vehicle, data, failed) {
    var grid = document.getElementById('js-productgrid--items');
    if (!grid) return;
    if (!failed) dropSidebar();
    /* 不适配的商品移出网格放进隐藏容器：主题按 nth-child 去掉每行第一张的左边距，只用 display:none 隐藏时序号还在，
       手机两列会错位留空（运营 2026-10-21）。车型在本页不会变，移出后不用再放回 */
    var holder = null;
    var run = function () {
      var shown = 0;
      Array.prototype.forEach.call(grid.querySelectorAll('[data-product-item]'), function (item) {
        var ok = !failed && fitsHandle(data, vehicle.yh, handleOf(item));
        if (ok) {
          shown += 1;
          return;
        }
        if (!holder) {
          holder = document.createElement('div');
          holder.hidden = true;
          holder.setAttribute('data-apsp-fit-hidden', '');
          grid.parentNode.insertBefore(holder, grid.nextSibling);
        }
        holder.appendChild(item);
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-viewing-count], [data-show-total-count]'), function (el) {
        el.textContent = String(shown);
      });
      var empty = document.querySelector('[data-apsp-fit-empty]');
      if (!shown && !empty) {
        empty = document.createElement('p');
        empty.setAttribute('data-apsp-fit-empty', '');
        empty.style.cssText = 'padding:24px 0;font-size:16px;';
        var link = document.createElement('a');
        link.href = '/pages/vehicle-year/' + vehicle.yh;
        link.textContent = vehicle.name;
        if (failed) {
          var retry = document.createElement('a');
          retry.href = window.location.href;
          retry.textContent = 'Try again';
          empty.appendChild(document.createTextNode("We couldn't confirm which parts fit your "));
          empty.appendChild(link);
          empty.appendChild(document.createTextNode(' right now. '));
          empty.appendChild(retry);
        } else {
          empty.appendChild(document.createTextNode('No parts in this category are listed for your '));
          empty.appendChild(link);
          empty.appendChild(document.createTextNode(' yet.'));
        }
        grid.parentNode.insertBefore(empty, grid);
      } else if (shown && empty) {
        empty.parentNode.removeChild(empty);
      }
    };
    run();
    /* Load more 追加的商品也要过滤 */
    if (window.MutationObserver) new MutationObserver(run).observe(grid, { childList: true });
  }

  function release() { if (document.documentElement) document.documentElement.classList.remove('apsp-fit-pending'); }

  function start(vehicle) {
    if (!vehicle || !vehicle.yh) { release(); return; }
    loadData(vehicle.yh).then(function (data) { apply(vehicle, data, false); release(); }, function () { apply(vehicle, null, true); release(); });
  }

  window.AuxitoVehicleCollectionFilter = { fitsHandle: fitsHandle, handleOf: handleOf };

  /* 车型直接从网址 ?vehicle= 读（PR #55 第六轮审查：原来等面包屑 HEAD 确认车型页存在后才启动，HEAD 失败时过滤永远不开始，商品全露出）。
     static-collection.liquid 在服务端输出时已给 html 加 apsp-fit-pending 先隐藏商品，适配确认后由 release() 放行。
     车型名优先取面包屑确认后的名字（同一份 sessionStorage 记录），没有就按 handle 还原。 */
  function vehicleFromUrl() {
    var yh = '';
    try { yh = new URLSearchParams(window.location.search).get('vehicle') || ''; } catch (e) { yh = ''; }
    if (!/^(19|20)\d{2}-[a-z0-9-]+$/.test(yh)) return null;
    var names = {};
    try { names = JSON.parse(window.sessionStorage.getItem('apsp:vehicle-names') || '{}') || {}; } catch (e) { names = {}; }
    var name = (window.__apspCollectionVehicle && window.__apspCollectionVehicle.yh === yh && window.__apspCollectionVehicle.name) || names[yh] ||
      yh.split('-').map(function (w) { return /^(hd|ld|ltd|ss|rs|gt|srt)$/.test(w) ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
    return { yh: yh, name: name };
  }

  /* 主题 Load more / 换排序 / 每页数量后用 pushState 改地址栏，拼的网址不带 ?vehicle=（empire.min.js），
     刷新或复制链接后就不再按车型过滤。同一集合页内改地址时把 vehicle 补回去（Astra 审查 2026-10-30） */
  function keepVehicleParam(yh) {
    ['pushState', 'replaceState'].forEach(function (fn) {
      var orig = window.history[fn];
      if (typeof orig !== 'function') return;
      window.history[fn] = function (state, title, url) {
        if (url != null) {
          try {
            var u = new URL(String(url), window.location.href);
            if (u.origin === window.location.origin && /^\/collections\//.test(u.pathname) && !u.searchParams.get('vehicle')) {
              u.searchParams.set('vehicle', yh);
              url = u.pathname + u.search + u.hash;
            }
          } catch (e) { /* 保持原网址 */ }
        }
        return orig.call(window.history, state, title, url);
      };
    });
  }

  /* 主题 Load more 用 [data-coll-url]（集合地址，不带标签）+ 侧栏选中的筛选拼下一页网址；网址里的车型标签（/collections/x/chevrolet-silverado）
     不在侧栏筛选里，第 2 页会变成整个集合（重复商品、别的车的商品）。把标签路径写进 data-coll-url（Astra 审查 2026-10-30 实测） */
  function keepTagPath() {
    var m = /^\/collections\/[^/]+\/[^/]+/.exec(window.location.pathname);
    var input = document.querySelector('[data-coll-url]');
    if (m && input && !/^\/collections\/[^/]+\/[^/]+/.test(input.value || '')) input.value = m[0];
  }

  function init() {
    var v = vehicleFromUrl();
    if (v) { keepVehicleParam(v.yh); keepTagPath(); }
    /* 旧车型页配件卡进来（?from=vehicle-page，没有年份页）：不按年份过滤，但 Load more 同样要带车型标签路径 */
    else {
      var from = '';
      try { from = new URLSearchParams(window.location.search).get('from') || ''; } catch (e) { from = ''; }
      if (from === 'vehicle-page') keepTagPath();
    }
    start(v);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
